export const doctor = 'bác sĩ';
